module.exports = __webpack_public_path__ + "static/media/PleaseLogin.0e8822b3.png";